import React, { useState, useCallback } from 'react';
import { Tabs } from 'antd';
import { TabsPane } from './styles';
import TabContent from './TabContent';
import PropTypes from 'prop-types';
const { TabPane } = Tabs;

export default function TabsComponent(props) {
  const [activeKey, setActiveKey] = useState('1');

  const handleChange = useCallback(
    (activeKey) => {
      props.handleTabAnalytics('tabClick', '', props.tabPanes[activeKey - 1].title);    
      setActiveKey(activeKey);
      props.getChange && props.getChange(activeKey);
    },
    [activeKey],
  )

  const {
    tabPanes,
    tabConfig,
    styling,
    containerHeight,
    enableScroll,
    transactionClicked,
    isLazyLoading,
  } = props;
  return (
    <TabsPane
      data-test = "tabs-pane"
      type="card"
      defaultActiveKey={activeKey}
      onChange={handleChange}
      className={`primary ${styling}`}
    >
      {tabPanes &&
        tabPanes.map((item, tabIndex) => (
          <TabPane
            style={{ color: '#022737' }}
            tab={`${item.title}`}
            key={`${item.key}`}
          >
            <TabContent
              data-test="tab-content"
              tabPanes={tabPanes}
              clicked={transactionClicked}
              key={tabIndex}
              item={item}
              tabIndex={tabIndex}
              tabConfig={tabConfig}
              containerHeight={containerHeight}
              enableScroll={enableScroll}
              activeKey={activeKey}
              noBorder={props.noBorder}
              yscrollC={props.yscrollC}
              xscroll={props.xscroll}
              accountType={props.accountType}
              dashboard={props.contributionDashboard}
              scrolled={(e, title) => props.scrolled(e, title)}
              isLazyLoading={isLazyLoading}
            />
          </TabPane>
        ))}
    </TabsPane>
  );
}

TabsComponent.propTypes = {
  dashboard: PropTypes.bool,
  containerHeight: PropTypes.string.isRequired,
  contributionDashboard: PropTypes.bool,
  scrolled: PropTypes.func,
  xscroll: PropTypes.bool,
  transactionClicked: PropTypes.func,
  handleTabAnalytics: PropTypes.func,
  isLazyLoading: PropTypes.bool,
  tabConfig: PropTypes.func,
  tabPanes: PropTypes.array,
};
